export const SCROLL_TO_LOCATION = 'scroll-to-location';
const scrollToLocation = ({ locationId }) => ({ type: SCROLL_TO_LOCATION, payload: { locationId } });
export default scrollToLocation;
